/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { SlackRow } from '@coursera-web/slack-account-link';

import { Card, Divider, Typography2 } from '@coursera/cds-core';

import { useSlackAccounts } from 'bundles/third-party-auth/components/AccountLink/hooks/useSlackAccounts';

import _t from 'i18n!nls/third-party-auth';

const styles = {
  card: css`
    &.cds-Card-base .cds-Card-innerCard {
      padding: var(--cds-spacing-200);
    }
  `,
  section: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-50);
  `,
  heading: css`
    margin: 0;
  `,
  rows: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-200);
    margin-top: var(--cds-spacing-100);
  `,
};

const AccountLinkSlack = () => {
  // TODO: add a loading skeleton and error state
  const { slackAccounts, loading, error } = useSlackAccounts();

  if (slackAccounts.length === 0 || loading || error) {
    return null;
  }

  return (
    <Card css={styles.card} interactive={false}>
      <section css={styles.section}>
        <Typography2 variant="subtitleLarge" component="h2" css={styles.heading}>
          {_t('Slack')}
        </Typography2>
        <div css={styles.rows}>
          {slackAccounts.map((account, index) => (
            <React.Fragment key={account.id}>
              {index > 0 && <Divider />}
              <SlackRow
                id={account.id}
                degreeId={account.degreeId}
                degreeName={account.degreeName}
                partnerName={account.partnerName}
                email={account.email}
                status={account.status}
                slackTeamDomainName={account.slackTeamDomainName}
              />
            </React.Fragment>
          ))}
        </div>
      </section>
    </Card>
  );
};

export default AccountLinkSlack;
